import { useState, useRef } from "react";
import { Message } from "../types";

export function useChatState({
  setMessages,
  messages,
}: {
  setMessages: any;
  messages: Message[];
}) {
  const [inputMessage, setInputMessage] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isSending, setIsSending] = useState<boolean>(false);
  const [hasMoreOlder, setHasMoreOlder] = useState<boolean>(true);
  const [hasMoreNewer, setHasMoreNewer] = useState<boolean>(false);
  const [isLoadingOlder, setIsLoadingOlder] = useState<boolean>(false);
  const [isLoadingNewer, setIsLoadingNewer] = useState<boolean>(false);
  const [loadError, setLoadError] = useState<string | null>(null);
  const [olderError, setOlderError] = useState<string | null>(null);
  const [newerError, setNewerError] = useState<string | null>(null);
  const [isAtBottom, setIsAtBottom] = useState(true);

  const messagesContainerRef = useRef<HTMLDivElement>(null);
  const topSentinelRef = useRef<HTMLDivElement>(null);
  const bottomSentinelRef = useRef<HTMLDivElement>(null);

  return {
    inputMessage,
    setInputMessage,
    isLoading,
    setIsLoading,
    isSending,
    setIsSending,
    hasMoreOlder,
    setHasMoreOlder,
    hasMoreNewer,
    setHasMoreNewer,
    isLoadingOlder,
    setIsLoadingOlder,
    isLoadingNewer,
    setIsLoadingNewer,
    loadError,
    setLoadError,
    olderError,
    setOlderError,
    newerError,
    setNewerError,
    isAtBottom,
    setIsAtBottom,
    messagesContainerRef,
    topSentinelRef,
    bottomSentinelRef,
    setMessages,
    messages,
  };
}
